import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.showActions
    ? _c(
        "div",
        { staticClass: "d-inline-flex align-center ga-2" },
        [
          _c(_setup.FavouriteBtn, {
            directives: [{ def: Ripple, name: "ripple", rawName: "v-ripple" }],
            class: _vm.roundedClass,
            attrs: {
              type: "doctors",
              size: _vm.size,
              "target-id": _vm.doctorId,
            },
          }),
          _vm._v(" "),
          _c(_setup.ShareBtn, {
            directives: [{ def: Ripple, name: "ripple", rawName: "v-ripple" }],
            class: _vm.roundedClass,
            attrs: {
              type: "doctor",
              "url-name": "doctor",
              size: _vm.size,
              url: _vm.doctorPageUrl,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }